<template>
  <md-card :style="{'margin-top':'0','margin-bottom': '0'}">
    <md-card-content class="md-layout" >
      <!-- <div class="md-layout-item md-size-100"></div> -->
      <div class="md-layout-item md-size-100 md-layout">
          <label class="md-layout-item md-size-30" :style="{'padding': '0 12px 0 30px','line-height':'63px'}">
            <span :style="{'font-size': '16px', 'font-weight':'bold'}">{{$I18n("dev_flow")}}</span>
          </label>
          <!-- 创建时间 (date) -->
          <div class="md-layout-item md-size-20 left-layout-item ml-auto" >
            <md-field class="md-theme-default md-has-value">
              <!-- <label>{{$I18n("create_time")}}</label> -->
              <el-date-picker
                class="md-date-form-item"
                align="left"
                v-model="line_date"
                type="daterange"
                prefixIcon="no"
                :clearable="false"
                range-separator="~"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptions"
                :start-placeholder="$I18n('start')"
                :end-placeholder="$I18n('end')">
              </el-date-picker>
            </md-field>
          </div>
          <div class="md-layout-item md-size-100 title"  :style="{'padding': '0 12px 0 30px','margin-top':'0px','margin-bottom':'20px'}">
            <div @click="line_type = 'create'" class="change" :class="{'selected_change': line_type=='create'}">{{$I18n("new_dev")}}</div>
            <div @click="line_type = 'update'" class="change" :class="{'selected_change': line_type=='update'}">{{$I18n("log_dev")}}</div>
            <div @click="line_type = 'total'" class="change" :class="{'selected_change': line_type=='total'}">{{$I18n("total_dev")}}</div>
          </div>
          <div class="md-layout-item md-size-100" id="line_chart" :style="charts"></div>
          <label class="md-layout-item md-size-30" :style="{'padding': '0 12px 0 30px','line-height':'63px'}">
            <span :style="{'font-size': '16px', 'font-weight':'bold'}">{{$I18n("top_ten_zone")}}</span>
          </label>
          <!-- 创建时间 (date) -->
          <div class="md-layout-item md-size-20 left-layout-item ml-auto" >
            <md-field class="md-theme-default md-has-value">
              <!-- <label>{{$I18n("create_time")}}</label> -->
              <el-date-picker
                class="md-date-form-item"
                align="left"
                v-model="bar_date"
                type="date"
                prefixIcon="no"
                :clearable="false"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptions"
                :start-placeholder="$I18n('start')"
                :end-placeholder="$I18n('end')">
              </el-date-picker>
            </md-field>
          </div>
          <div class="md-layout-item md-size-100 title"  :style="{'padding': '0 12px 0 30px','margin-top':'0px','margin-bottom':'20px'}">
            <div @click="bar_type = 'create'" class="change" :class="{'selected_change': bar_type=='create'}">{{$I18n("new_dev")}}</div>
            <div @click="bar_type = 'update'" class="change" :class="{'selected_change': bar_type=='update'}">{{$I18n("log_dev")}}</div>
            <div @click="bar_type = 'total'" class="change" :class="{'selected_change': bar_type=='total'}">{{$I18n("total_dev")}}</div>
          </div>
          <div class="md-layout-item md-size-100" id="bar_chart" :style="charts"></div>
      </div>
    </md-card-content>
  </md-card>
</template>
<script>
import { nDaysAgo, timestampToString1000 } from "@/common/tools.js";
import * as echarts from "echarts";

export default {
  props: ["userinfo_sys"],
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() >= new Date(nDaysAgo(0));
        },
      },
      charts : {
        height : '100px',
      },
      line_date  : [nDaysAgo(7), nDaysAgo(1)],
      line_type  : "create",
      line_data  : {
        create : {
          axis : [],
          series : []
        },
        update : {
          axis : [],
          series : []
        },
        total  : {
          axis : [],
          series : []
        },
      },
      bar_date   : nDaysAgo(1),
      bar_type   : "create",
      bar_data   : {
        create : {
          axis : [],
          series : []
        },
        update : {
          axis : [],
          series : []
        },
        total : {
          axis : [],
          series : []
        },
      },
      lineCharts  : {},
      barCharts   : {},
    };
  },
  methods:{
    api_getLine(){
      return this.$api.queryDevRegAna({
        gmt_start : this.line_date.length && this.line_date.length[0] ? parseInt(new Date(this.line_date[0] + " 00:00:00").getTime()/1000): 0,
        gmt_end   : this.line_date.length && this.line_date.length[1] ? parseInt(new Date(this.line_date[1] + " 00:00:00").getTime()/1000): 0,
        link_id    : this.userinfo_sys,
        link_type  : 3,
      })
        .then(this.$Then(res => {
          var d_range = (new Date(this.line_date[1]) - new Date(this.line_date[0])) / (1000 *3600 *24) + 1;
          var d_now = (new Date(this.line_date[1]) - new Date(nDaysAgo(0))) / (1000 * 3600 *24) + 1;
          this.line_data = {
            create : {
              axis : [],
              series : []
            },
            update : {
              axis : [],
              series : []
            },
            total  : {
              axis : [],
              series : []
            },
          }
          for(var i =0; i < d_range ; i++){
            this.line_data.create.axis.push(nDaysAgo(d_range-i - d_now))
            this.line_data.update.axis.push(nDaysAgo(d_range-i - d_now))
            this.line_data.total.axis.push(nDaysAgo(d_range-i - d_now))
            var itemData = res.data.filter(function(item){
              return timestampToString1000(item.gmt_create).split(" ")[0] == nDaysAgo(d_range-i - d_now)
            })
            if (itemData.length == 0) {
              this.line_data.create.series.push(0)
              this.line_data.update.series.push(0)
              this.line_data.total.series.push(0)
            } else {
              this.line_data.create.series.push(itemData[0].create_count? itemData[0].create_count :0)
              this.line_data.update.series.push(itemData[0].update_count? itemData[0].update_count :0)
              this.line_data.total.series.push(itemData[0].total_count? itemData[0].total_count :0)
            }
          }
        }))
        .catch(this.$Catch(this.$I18n("unknown_error"),() => {
          this.line_data = {
            create : {
              axis : [],
              series : []
            },
            update : {
              axis : [],
              series : []
            },
            total  : {
              axis : [],
              series : []
            },
          }
        }));
    },
    api_getBar(){
      return  this.$api.queryDevRegAna({
        gmt_start  : parseInt(new Date(this.bar_date + " 00:00:00").getTime()/1000),
        gmt_end    : parseInt(new Date(this.bar_date + " 23:59:59").getTime()/1000),
        link_id    : this.userinfo_sys,
        link_type  : 3,
      })
        .then(this.$Then(res => {
          this.bar_data  = {
            create : {
              axis : [],
              series : []
            },
            update : {
              axis : [],
              series : []
            },
            total : {
              axis : [],
              series : []
            },
          }
          var barItem = res.data

          var get10 =  (barDataJSON) => {
            var top10NameArray = [];
            var top10CountArray = [];
            for(var key in barDataJSON) {
              if (top10CountArray.length == 0 ) {
                top10NameArray = [this.$I18n(key? key :"unknow")]
                top10CountArray = [barDataJSON[key]]
              } else {
                for(var i = 0; i < top10CountArray.length ; i ++) {
                  if (top10CountArray[i] < barDataJSON[key]) {
                    top10NameArray.splice(i,0, this.$I18n(key? key :"unknow"))
                    top10CountArray.splice(i,0, barDataJSON[key])
                    break
                  }
                }
                if (top10CountArray.length < 10 && top10NameArray.indexOf(this.$I18n(key)) == -1) {
                  // console.log(key)
                  top10NameArray.push(this.$I18n(key? key :"unknow"))
                  top10CountArray.push(barDataJSON[key])
                }else if (top10CountArray.length > 10) {
                  top10NameArray = top10NameArray.splice(0,10)
                  top10CountArray = top10CountArray.splice(0,10)
                }
              }
            }
            return [top10NameArray.reverse(), top10CountArray.reverse()]
          }
          if(barItem.length != 0) {
            if (barItem[0].create_zone){
              let top10 = get10(barItem[0].create_zone)
              this.bar_data.create.axis = top10[0]
              this.bar_data.create.series = top10[1]
            }
            if (barItem[0].update_zone) {
              let top10 = get10(barItem[0].update_zone)
              this.bar_data.update.axis = top10[0]
              this.bar_data.update.series = top10[1]
            }
            if (barItem[0].total_zone) {
              let top10 = get10(barItem[0].total_zone)
              this.bar_data.total.axis = top10[0]
              this.bar_data.total.series = top10[1]
            }
          }
        }))
        .catch(this.$Catch(this.$I18n("unknown_error"), () => {
          this.bar_data  = {
            create : {
              axis : [],
              series : []
            },
            update : {
              axis : [],
              series : []
            },
            total : {
              axis : [],
              series : []
            },
          }
        }));
    },
    charts_buildBar(){
      if(this.barCharts.clear){
        this.barCharts.clear()
      }
      if(this.lineCharts.resize){
        this.lineCharts.resize()
      }
      if(this.barCharts.resize){
        this.barCharts.resize()
      }
      this.barCharts.setOption({
        grid: {
          top: 10,
          left: 80,
          right: 50,
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        xAxis: {
          type: 'value',
          boundaryGap: [0, 0.01],
          axisLine:{
            show: false,
          },
          axisTick: {
            show : false,
          },
          splitLine: {
            show: true,
            lineStyle:{
              type:"dashed"
            }
          },
          // show : true,
          splitArea: 7
        },
        yAxis: {
          type: 'category',
          data: this.bar_data[this.bar_type].axis,
          axisLine:{
            lineStyle:{
              color: "#888888",
            }
          },
          axisTick: {
            lineStyle:{
              color: "#dedede",
            }
          },

        },
        series: [{
          type: "bar",
          barMaxWidth : 20,
          color: "#00bcd4",
          data: this.bar_data[this.bar_type].series,
          label: {
            show: true,
            position: 'right',
            valueAnimation: true
          },
        }]
      })
    },
    charts_buildLine(){
      if(this.lineCharts.clear){
        this.lineCharts.clear()
      }
      if(this.lineCharts.resize){
        this.lineCharts.resize()
      }
      if(this.barCharts.resize){
        this.barCharts.resize()
      }
      this.lineCharts.setOption({
        // legend: {
        //     left: 30,
        //     data: ['新增人数', '登录人数', '总人数']
        // },
        grid: {
          top: 10,
          left: 80,
          right: 50,
        },
        tooltip: {
          trigger: 'axis',
          textStyle:{
            align:"left"
          },
          axisPointer: {            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        xAxis: {
          type: 'category',
          data: this.line_data[this.line_type].axis,
          axisLine:{
            lineStyle:{
              color: "#888888",
            }
          },
          axisTick: {
            lineStyle:{
              color: "#dedede",
            }
          },
        },
        yAxis: {
          type: 'value',
          axisLine:{
            show: false,
          },
          axisTick: {
            show : false,
          },
          splitLine: {
            show: true,
            lineStyle:{
              type:"dashed"
            }
          },
          // show : true,
          splitArea: 7
        },
        series: [{
          data: this.line_data[this.line_type].series,
          // name: "新增人数",
          // stack: "count1",
          type: 'line',
          color: "#00bcd4"
        }]
      })
    },
    getHeight(){
      this.charts.height= (window.innerHeight-400)  +'px';
      if(this.barCharts.resize){
        setTimeout(this.barCharts.resize,0);
      }
      if(this.lineCharts.resize){
        setTimeout(this.lineCharts.resize,0);
      }
    },
  },
  created(){
    window.addEventListener('resize', this.getHeight);
  },
  mounted : function() {
    // 地图图表
    // this.getHeight()
    this.lineCharts = echarts.init(document.getElementById('line_chart'));
    this.barCharts = echarts.init(document.getElementById('bar_chart'));
    this.api_getBar()
      .then(this.api_getLine)
      .then(() => {
        // this.getHeight();
        this.charts_buildBar ();
        this.charts_buildLine ();
        this.getHeight();
      })
  },
  watch: {
    line_type(){
      this.charts_buildLine()
    },
    bar_type(){
      this.charts_buildBar()
    },
    userinfo_sys(){
      this.api_getBar()
        .then(this.api_getLine)
        .then(() => {
          this.charts_buildBar ();
          this.charts_buildLine ();
        })
    },
    line_date(){
      this.api_getLine().then(this.charts_buildLine)
    },
    bar_date(){
      this.api_getBar().then(this.charts_buildBar)
    },
    compLayerData (to) {
      this.compTableData = [...this.sortArray(to.map(item => {
        return {
          id:item.id,
          name: item.name,
          total: item.data.total_count,
          cny: Math.round(item.data.cny_order_amount),
          usd: Math.round(item.data.usd_order_amount),
        }
      }))].splice(0,5)
    },
    appLayerData (to) {
      this.appTableData = [...this.sortArray(to
        .filter(item => {
          return !!item.data.__TOTAL__.total_count
        })
        .map(item => {
          return {
            name: item.name,
            total: item.data.__TOTAL__.total_count,
            cny: Math.round(item.data.__TOTAL__.cny_order_amount),
            usd: Math.round(item.data.__TOTAL__.usd_order_amount),
          }
        })
      )].splice(0,5)
    },
    dateType (){
      this.getOrderData();
    },
    // openModal (to){
    //   if (!to) {
    //     if (this.openModalType === "add" || this.openModalType === "edit" || this.openModalType === "delete"){
    //       this.api_getPageData();
    //     }else {
    //       this.api_getPageDataOnlySub();
    //     }
    //     this.error = {}
    //   }
    // },
    // searchForm(){
    //   this.selectedMain = {};
    //   this.api_getAttrName()
    //     .then(() => {
    //       this.api_getPageData();
    //     })
    // },
  },
  computed: {
    modalTableData (){
      return [...this.modalData].splice((this.currentPage-1) * this.pageSize, this.pageSize)
    },
  },
}
</script>
<style lang="scss" scoped>
  .md-layout-item{
    transition: all 0s;
  }
  #line_chart, #bar_chart {
      width: 100%;
      height: 450px;
  }
  #chart {
      /*display: none;*/
  }
  .title {
      font-size:  16px;
      color: rgb(12,110,220);
      box-sizing: border-box;
      margin: 0;
      padding: 0;
      color: #252934;
      font-size: 12px;
      font-variant: tabular-nums;
      line-height: 1.5;
      list-style: none;
      font-feature-settings: 'tnum';
      display: inline-block;
      margin-top: 72px;
      width: 100%;
      position: relative;
  }
  .title div:hover, .title .selected_change{
      /*color: #ffffff;*/
      cursor: pointer;
      border-color: #3B82FE !important;
  }
  .title span{
      display: inline-block;
      float: left;
  }
  .title .change{
      font-size: 14px;
      float: left;
      position: relative;
      display: inline-block;
      height: 26px;
      margin: 0;
      padding: 0 15px;
      color: #252934;
      line-height: 26px;
      background: #FFF;
      border: 1px solid #E1E4E8;
      border-top-width: 1.02px;
      /*border-left: 0;*/
      cursor: pointer;
      transition: color 0.3s, background 0.3s, border-color 0.3s;
  }
  /*.change.selected_change{
      background-color: #1777c5;
  }
  .change:hover{
      color: rgb(12,110,220) !important;
  }
  .change.selected_change:hover{
      color: #ffffff !important;
  }
  .change {
      font-size: 12px !important;
      margin: 13px 0px !important;
      padding: 2px !important;
      border: 1px solid #80d4f8;
      height: 16px;
      line-height: 16px;
      text-align: center;
  }*/
  .comp_info{
      font-size: 24px;
      /*font-weight: 600;*/
      color: black;
      position: absolute;
      top : -62px;
      background-color: #edeff4;
      /*width: 100%;*/
      height: 42px;
      left:0 ;
      right: 0;
      line-height: 42px;
      padding-left: 12px;
      color: rgb(0, 0, 0);
      font-size: 16px;
      padding: 4px 20px;
      background: rgb(247, 248, 250);
      margin-bottom: 20px;
  }
  .title{
      position: relative;
  }
  #go_back_app_list {
      margin-left: 20px;
      display: inline-block;
      font-size: 16px;
      color: #42a6f5;
      cursor: pointer;
  }
  .data_type_3 {
      margin-left: 20px !important;
  }
  .layui-form-item.form_btn_item>div{
      text-align: left !important;
  }
  #total_info .info_box{
      /*height: 32px; */
      background-color: #999999; 
      display:inline-block; 
      width: 49%; 
      margin: 0 .4%;
      font-size: 16px;
      line-height: 32px;
      padding-top: 8px ;
      padding-bottom: 8px ;
      color: #ffffff;
      border-radius: 4px;
  }
  #total_info .info_box p {
      margin: 12px 24px;
  }
  #total_info .info_box span {
      height: 32px;
      display: inline-block;
  }
  #total_info .info_count_{
      font-size: 30px;
  }
  #total_info .info_type_ {
      font-size: 20px;
      position: relative;
      top: -4px;
  }
  #total_info .info_name_ {
      position: relative;
      top: -6px;
  }
  #total_info .iconfont {
      font-size:  30px;
      /*font-weight: bold;*/
      color: rgba(255, 255, 255, .5)
  }
  #total_info .info_box span ,
  #total_info .info_box i {
      margin-right: 16px;
  }
  #total_info .info_box:nth-child(1){
      background-image: linear-gradient(to right, #2070ff , #41a2ff);
  }
  #total_info .info_box:nth-child(3){
      /*background-image: linear-gradient(to right, #ff8a17 , #ffa22d);*/
  }
  #total_info .info_box:nth-child(2){
      background-image: linear-gradient(to right, #6b5efe , #5889fe);
  }
  #date_info_form, #zone_info_form {
      position: absolute;
      left: 0;
      right: 16px;
      top: -63px;
      z-index: 100;
  }
  #date_info_form .layui-form-item, #zone_info_form .layui-form-item{
      float: right;
  }
  
  #app_id {

      width: 320px;
  }
  #app_id .layui-input-block {
      margin-left: 18px;
  }
  .diy_form .layui-form label {
      line-height: 24px;
  }
  .diy_form .layui-form input, .diy_form .layui-form select {
      border-radius: 2px;
      height: 36px;
  }
  #app_id_input {
      position: relative;
  }
  #app_id_input label{
      position: absolute;
      z-index: 10;
      width: 72px;
  }
  #app_id_input .layui-input-block {
      margin-left:16px;
  }
  #app_id_input input{
      padding-left: 90px;
  }
</style>